export function createTimerWorker() {
    return new Worker(
        new URL('./timerWorker.js', import.meta.url)
    );
}